import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,

} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';

import { BaseModule } from './views/base/base.module';
import { ToastrModule } from 'ngx-toastr';
import { ForgotPasswordComponent } from './views/forgot-password/forgot-password.component';
import { VerifyOTPComponent } from './views/verify-otp/verify-otp.component';
import { SetNewPasswordComponent } from './views/set-new-password/set-new-password.component';
import { SimpleModalModule } from 'ngx-simple-modal';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { TokenInterceptor } from './auth/TokenInterceptor';
import { DefaultLayoutAddComponent } from './containers/default-layout/default-layout-add/default-layout-add.component';
import { DefaultService } from './containers/default-layout/default.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgxSummernoteModule } from 'ngx-summernote';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { PartnerCommissionSettingsComponent } from './partner-commission-settings/partner-commission-settings.component';
import { ReferralToggleComponent } from './referral-toggle/referral-toggle.component';

@NgModule({
  imports: [
    
    GooglePlaceModule,
    NgxSummernoteModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    IconModule,
    IconSetModule.forRoot(),
    FormsModule,
    BaseModule,
    HttpClientModule,
    ReactiveFormsModule,
    OverlayModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    SimpleModalModule.forRoot({ container: "modal-container" }),
    NgProgressModule,
    NgProgressHttpModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    VerifyOTPComponent,
    SetNewPasswordComponent,
    DefaultLayoutAddComponent,
    ReferralToggleComponent
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    IconSetService,
    DefaultService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
